import React from 'react';
import { IMAGES_REPO } from '../../../config';

const ComponentView = ({ isSelected, name, image, url }) => {
  return (
    <div className={isSelected ? 'partner-view partner-view--selected' : 'partner-view'}>
      <div className="partner-view__image-container">
        <img src={IMAGES_REPO + '' + image}/>
      </div>
      <label className="partner-view__name">{name}</label>
      <br/>
      <label className="partner-view__name">{url}</label>
    </div>
  );
};

export default ComponentView



// WEBPACK FOOTER //
// ./src/components/ListEntity/Entities/Partner.js